import { useContext } from "react";
import { CommonComponentContext } from "../utils/CommonComponentContext";

export function useGlossary() {
    const commonContext = useContext(CommonComponentContext);
    return commonContext.glossary;
}

export default useGlossary;